<div style="height: 75vh;overflow: hidden;overflow-y: scroll;">
    <div class="row">
        <div class="col-sm-12 col-lg-12">
            <mat-card class="cardWithShadow">
                <mat-card-content class="p-y-24">
                    <mat-card-title>
                        <div>
                            <i-tabler style="margin-right: 5px;" name="devices-bolt" class="icon-16"></i-tabler>
                            {{ "Imprimante mobile" | translate }}
                        </div>
                    </mat-card-title>
                    <div class="m-t-24 row">
                        <div class="col-12" *ngIf="btPrinterService.btPrinterDeviceConnected != null">
                            <div style="padding: 5px 0px; margin-bottom: 5px; font-weight: bold;"><span>Imprimante connectée</span></div>
                            <button mat-flat-button color="warn" style="width: 100%" (click)="doDisconnectBTDevice()">
                                <mat-icon>bluetooth_connected</mat-icon> Déconnecter l'imprimante
                            </button>
                        </div>
                        <div class="col-12" *ngIf="btPrinterService.btPrinterDeviceConnected == null">
                            <div style="padding: 5px 0px; margin-bottom: 5px;"><span>Aucune imprimante connectée</span></div>
                            <button mat-flat-button color="primary" style="width: 100%" (click)="doConnectBtPrinter()">
                                <mat-icon>bluetooth_searching</mat-icon> Connecter une imprimante
                            </button>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>


    <div class="row">
        <div class="col-sm-12 col-lg-12">
            <mat-card class="cardWithShadow">
                <mat-card-content class="p-y-24">
                    <mat-card-title>
                        <div>
                            <i-tabler style="margin-right: 5px;" name="devices-bolt" class="icon-16"></i-tabler>
                            {{ "Agent CaurisLinkup" | translate }}
                        </div>
                    </mat-card-title>
                    <div class="m-t-24 row">
                        <div class="col-lg-12">
                            <mat-form-field appearance="outline" class="w-100" color="primary" [floatLabel]="'always'">
                                <mat-label class="mat-subtitle-2 f-s-14 f-w-600">{{ "Adresse Agent CaurisLinkup" | translate }}</mat-label>
                                <input matInput [formControl]="cluAgentAddressFormControl" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="error-container" *ngIf="!!errorStartupInfosText">{{ errorStartupInfosText }}</div>
                    <div class="d-flex justify-content-end" style="gap: 10px">
                        <button mat-flat-button color="primary" [disabled]="loadingStartupInfosText" (click)="doConnectCLUAgentAction()" *ngIf="startupInfos == null">
                            <ng-container *ngIf="loadingStartupInfosText"><mat-spinner diameter="25"></mat-spinner></ng-container>
                            <ng-container *ngIf="!loadingStartupInfosText">{{ "Connecter" | translate }}</ng-container>
                        </button>
                        <button mat-flat-button color="warn" [disabled]="loadingStartupInfosText" (click)="doDisconnectCLUAgentAction()" *ngIf="startupInfos != null">
                            {{ "Se déconnecter" | translate }}
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <ng-container *ngIf="!!startupInfos">
        <div class="row">
            <div class="col-sm-12 col-lg-12">
                <mat-card class="cardWithShadow">
                    <mat-card-content class="p-y-24">
                        <mat-card-title>
                            <div>
                                <i-tabler style="margin-right: 5px;" name="3d-cube-sphere" class="icon-16"></i-tabler>
                                {{ "Périphériques" | translate }}
                            </div>
                        </mat-card-title>
                        <form [formGroup]="paramsFormGroup" (ngSubmit)="doSaveParamsAction()">
                            <div class="m-t-24 row">
                                <div class="col-lg-12">
                                    <div style="display: flex; flex-direction: row">
                                        <mat-form-field appearance="outline" color="primary" [floatLabel]="'always'" style="flex: 1">
                                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600">{{ "Imprimante Standard" | translate }}</mat-label>
                                            <mat-select formControlName="STD_PRINTER_ID">
                                                <mat-option value="" selected>{{ "Aucune imprimante définie" | translate }}</mat-option>
                                                <ng-container *ngFor="let item of startupInfos.STD_PRINTERS">
                                                    <mat-option [value]="item.ID">{{ item.NAME }}</mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                        <button mat-flat-button type="button" color="tertiary" [disabled]="!paramsFormGroup.controls.STD_PRINTER_ID.value" (click)="doConfigureStandardPrinterAction()" matSuffix style="height: 55px;border-radius: 0px;">
                                            <i-tabler name="settings"></i-tabler>
                                        </button>
                                        <button mat-flat-button type="button" color="primary" [disabled]="!paramsFormGroup.controls.STD_PRINTER_ID.value" (click)="doTestStdPrinterAction()" matSuffix style="height: 55px;border-radius: 0px;">{{ "Tester" | translate }}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div style="display: flex; flex-direction: row">
                                        <mat-form-field appearance="outline" color="primary" [floatLabel]="'always'" style="flex: 1">
                                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600">{{ "Imprimante Ticket" | translate }}</mat-label>
                                            <mat-select formControlName="PRINTER_ID">
                                                <mat-option value="" selected>{{ "Aucune imprimante définie" | translate }}</mat-option>
                                                <ng-container *ngFor="let item of startupInfos.SPRINTERS">
                                                    <mat-option [value]="item.ID">{{ item.NAME }}</mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                        <button mat-flat-button type="button" color="primary" [disabled]="!paramsFormGroup.controls.PRINTER_ID.value" (click)="doTestPrinterAction()" matSuffix style="height: 55px;border-radius: 0px;">{{ "Tester" | translate }}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div style="display: flex; flex-direction: row">
                                        <mat-form-field appearance="outline" color="primary" [floatLabel]="'always'" style="flex: 1">
                                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600">{{ "Afficheur de caisse" | translate }}</mat-label>
                                            <mat-select formControlName="DISPLAY_ID">
                                                <mat-option value="" selected>{{ "Aucun afficheur défini" | translate }}</mat-option>
                                                <ng-container *ngFor="let item of startupInfos.SDISPLAYS">
                                                    <mat-option [value]="item.ID">{{ item.NAME }}</mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                        <button mat-flat-button type="button" color="primary" [disabled]="!paramsFormGroup.controls.DISPLAY_ID.value" (click)="doTestDisplayAction()" matSuffix style="height: 55px;border-radius: 0px;">{{ "Tester" | translate }}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div style="display: flex; flex-direction: row">
                                        <mat-form-field appearance="outline" color="primary" [floatLabel]="'always'" style="flex: 1">
                                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600">{{ "Balance de caisse" | translate }}</mat-label>
                                            <mat-select formControlName="CASH_BALANCE_ID">
                                                <mat-option value="" selected>{{ "Aucune balance définie" | translate }}</mat-option>
                                                <ng-container *ngFor="let item of startupInfos.SDISPLAYS">
                                                    <mat-option [value]="item.ID">{{ item.NAME }}</mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="error-container" *ngIf="!!errorText">{{ errorText }}</div>
                            <div class="d-flex justify-content-end">
                                <button mat-flat-button type="submit" color="primary" [disabled]="loading">
                                    <ng-container *ngIf="loading"><mat-spinner diameter="25"></mat-spinner></ng-container>
                                    <ng-container *ngIf="!loading">Enregistrer</ng-container>
                                </button>
                            </div>
                        </form>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </ng-container>
</div>
